import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { DishServices } from '../../../dish/services';
import { VariationsCreateFavSelectPage } from '../../../variations/variations-create-fav-select/variations-create-fav-select';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the ArticleViewVariationsFavsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-article-view-variations-favs',
    templateUrl: 'article-view-variations-favs.html',
})
export class ArticleViewVariationsFavsPage {
    @Input() article: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public dishServices: DishServices) {

    }

    editFavVarations() {
        if (this.article.type === 'dish') {
            if (this.globals.checkLimitsByLicense('dishes', 'variations_favourites')) {//version pro abierto
                this.navCtrl.push(VariationsCreateFavSelectPage, {
                    update: true,
                    dish_uid: this.article.UID,
                    dish_name: this.globals.nameLangSelectDish(this.article),
                    fav_variations: this.article.variations_favourite,
                    origin: 'dish',
                    dish: this.article,
                })
            } else {
                this.navCtrl.push(AddonsTriggerVersionProPage);
            }
        } else {
            if (this.globals.checkLimitsByLicense('stock', 'variations_favourites')) {//version pro abierto
                this.navCtrl.push(VariationsCreateFavSelectPage, {
                    update: true,
                    product_uid: this.article.UID,
                    product_name: this.article.name,
                    fav_variations: this.article.variations_favourite,
                    origin: 'product',
                    product: this.article
                });
            } else {
                this.navCtrl.push(AddonsTriggerVersionProPage);
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/pages/articles/articles-view/article-view-variations-favs/article-view-variations-favs.ts